import React, { useEffect, useState } from "react";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
    setIsTableLoading,
    setTotalItems,
    setItems,
    setPage,
    setRowsPerPage,
    setSearchValue,
} from "src/redux/slices/GoalCategoriesSlice";
import { RxPencil1 } from "react-icons/rx";
import GoalCategoriesListing from "./GoalCategoriesListing";
import { MdDeleteOutline } from "react-icons/md";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import AddGoalCategoriesFormWrapper from "../Add/AddGoalCategoriesFormWrapper";
import EditGoalCategoriesFormWrapper from "../Edit/EditGoalCategoriesFormWrapper";
import { useDeleteGoalCateGoryMutation, useGetGoalCategoriesQuery } from "src/services/GoalCategoryServices";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";

type Props = {};

const GoalListingListingWrapper = (props: Props) => {
    const [isOpenAddForm, setIsOpenAddForm] = useState(false)
    const [isOpenEditFrom, setIsOpenEditForm] = useState(false);
    const [goalId, setGoalId] = useState("")
    const dispatch = useDispatch();
    
    const [deleteGoalCateGory] = useDeleteGoalCateGoryMutation()
    const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
        useSelector((state: RootState) => state.goalCategories);
    const { data, isLoading, isFetching } = useGetGoalCategoriesQuery({
        limit: rowsPerPage,
        searchValue: searchValue,
        params: [
            "categoryName"
        ],
        page: page,
        dateFilter: {},
        filterBy: [],
        orderBy: "createdAt",
        orderByValue: -1,
        isPaginationRequired: true
    })
    useEffect(() => {
        if (isLoading || isFetching) {
            dispatch(setIsTableLoading(true));
        } else {
            dispatch(setItems(data?.data || []));
            dispatch(setTotalItems(data?.totalItem || 0));
            dispatch(setIsTableLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, isLoading, isFetching]);


    const getActionOptions = (goalId: string) => {
        return [
            {
                label: (
                    <div className="flex items-center gap-2 text-secondary-main">
                        <RxPencil1 className="text-lg" /> Edit
                    </div>
                ),
                onClick: () => {
                    setGoalId(goalId)
                    setIsOpenEditForm(true)
                },
                actionName: UserModuleActionTypes.EDIT,
                moduleName: UserModuleNameTypes.GOAL_CATEGORY,
            },
            {
                label: (
                    <div className="flex items-center gap-2 font-semibold text-red-600">
                        <MdDeleteOutline className="text-lg" /> Delete
                    </div>
                ),
                onClick: () => {
                    showConfirmationDialog({
                        title: "Heads Up",
                        text: "Are you sure want to Delete this category name ?",
                        icon: "question",
                        showCancelButton: true,
                        next: (result) => {
                            if (result?.isConfirmed) {
                                deleteGoalCateGory(goalId).then((res: any) => {
                                    if (res?.error) {
                                        showToast("error", res?.error?.data?.message);
                                    } else {
                                        if (res?.data?.status) {
                                            showToast("success", res?.data?.message);
                                        } else {
                                            showToast("error", res?.data?.message);
                                        }
                                    }
                                });
                            }
                        },
                    });
                },
                actionName: UserModuleActionTypes.DELETE,
                moduleName: UserModuleNameTypes.GOAL_CATEGORY,
            }
        ]
    }

    const columns: columnTypes[] = [
        { field: "categoryName", headerName: "category Name", flex: "flex-[1_1_0%]", extraClasses: "capitalize", },
        {
            field: "action",
            headerName: "action",
            flex: "flex-[1_1_0%]",
            extraClasses: "capitalize min-w-[120px]",
            align: "end",
            renderCell: (row: any) => {
                const options = getActionOptions(row?._id);
                return <ATMMenu options={options} orientation="vertical" />;
            },
        },
    ];


    return (
        <div>
            <GoalCategoriesListing
                columns={
                    isCheckColumnPermission({
                        moduleName: UserModuleNameTypes.GOAL_CATEGORY,
                        actionName: UserModuleActionTypes.LIST,
                        columns: columns
                      })
                }
                rows={items}
                getActionOptions={getActionOptions}
                onAddNew={() => { setIsOpenAddForm(true) }}
                paginationProps={{
                    isTableLoading,
                    totalItems,
                    page,
                    rowsPerPage,
                    searchValue,
                    setPage: (newPage) => dispatch(setPage(newPage)),
                      setRowsPerPage: (newRowsPerPage) =>
                        dispatch(setRowsPerPage(newRowsPerPage)),
                    setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
                }}
            />
            {isOpenAddForm && <AddGoalCategoriesFormWrapper onClose={() => setIsOpenAddForm(false)} />}
            {isOpenEditFrom && <EditGoalCategoriesFormWrapper goalId={goalId} onClose={() => setIsOpenEditForm(false)} />}
        </div>
    );
};

export default GoalListingListingWrapper;
